import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { DIFFICULTY_COLORS } from "../../../config/chartColors";
import type { CardDifficultyDistribution } from "../../../generated/graphql";

interface CardDifficultyChartProps {
  data: CardDifficultyDistribution[];
}

export function CardDifficultyChart({ data }: CardDifficultyChartProps) {
  if (!data || data.length === 0) {
    return (
      <div className="chart-container">
        <div className="chart-empty">No difficulty distribution data available</div>
      </div>
    );
  }

  const chartData = data.map((item) => ({
    name: item.range,
    value: item.count,
    percentage: item.percentage,
  }));

  return (
    <div className="chart-container">
      <div className="chart-header">
        <h4 className="h6">Card Difficulty Distribution</h4>
      </div>
      <div className="chart-body">
        <ResponsiveContainer width="100%" height={400}>
          <PieChart>
            <Pie
              data={chartData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={120}
              label={({ name, percent }) => `${name}: ${((percent || 0) * 100).toFixed(1)}%`}
            >
              {chartData.map((entry) => (
                <Cell
                  key={entry.name}
                  fill={
                    DIFFICULTY_COLORS[entry.name as keyof typeof DIFFICULTY_COLORS] ||
                    DIFFICULTY_COLORS.Other
                  }
                />
              ))}
            </Pie>
            <Tooltip
              formatter={(value: number | undefined) =>
                value !== undefined ? `${value} cards` : ""
              }
            />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
